<template>
  <div>
    <div class="text-weight-bold">Tipo</div>
    <q-select
      v-model="tipo"
      :options="listaTipos"
      @filter="filterFn"
      use-input
      dense
      outlined
      option-label="nome"
      option-value="uuid"
    >
      <template v-slot:no-option>
        <q-item>
          <q-item-section class="text-italic text-grey">
            Nenhum tipo encontrado
          </q-item-section>
        </q-item>
      </template>
    </q-select>
  </div>
</template>

<script setup>
import { ref, watch, defineProps, defineEmits } from "vue";
import { useStore } from "vuex";

const props = defineProps(["categoriaUuid", "resetar", "model"]);
const emit = defineEmits(["enviarTipo"]);
const time = ref();
const store = useStore();

const tipo = ref(props.model);
const listaTipos = ref([]);

const listarTipo = async (val) => {
  try {
    const response = await store.dispatch("documento/listarTipos", {
      unidadeId: store.state.org.unidadeData.id,
      categoriaUuid: props.categoriaUuid,
      perPage: 100,
      nome: val,
    });
    listaTipos.value = response.data.resultado.dados;
  } catch (error) {
    console.log(error);
  }
};

watch(
  () => tipo.value,
  () => {
    if (tipo.value != "") {
      emit("enviarTipo", tipo.value);
    }
  }
);

watch(
  () => props.categoriaUuid,
  () => {
    if (
      tipo.value?.categoriaUuid != props.categoriaUuid ||
      props.categoriaUuid == undefined ||
      props.categoriaUuid === ""
    ) {
      tipo.value = "";
    }
  }
);

watch(
  () => props.model,
  () => {
    tipo.value = props.model;
  }
);

watch(
  () => props.resetar,
  () => {
    if (
      tipo.value?.categoriaUuid != props.categoriaUuid &&
      tipo.value?.categoriaUuid != ""
    ) {
      tipo.value = "";
    }
  }
);

function filterFn(val, update, abort) {
  clearTimeout(time.value);
  if (val.length < 1) {
    abort();
    return;
  }

  time.value = setTimeout(() => {
    listarTipo(val);
  }, 2000);

  setTimeout(() => {
    update();
  }, 2500);
}
</script>
